import * as ActionTypes from '../../actions/allActions'

const authInit = { signedIn: false, token: "", tokenChecked: false }
const auth = (state = authInit, action) => {
	switch (action.type) {
		case ActionTypes.SIGNIN_SUCCESS:
		case ActionTypes.CHECKTOKEN_SUCCESS:
			return { ...state, signedIn: true, token: action.data.data.attributes.token }
		case ActionTypes.TOKEN_CHECKED:
			return { ...state, tokenChecked: true }
		case ActionTypes.LOGOUT:
			return { ...authInit, tokenChecked: true }
		default:
			return state
	}
}

export default auth


// WEBPACK FOOTER //
// ./src/reducers/metadata/auth.js